import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DxDateBoxModule, DxValidatorModule } from 'devextreme-angular';
import { FormValidationComponent } from '../form-validation/form-validation.component';

@Component({
    selector: 'form-item-date',
    template: ` <dx-date-box
    [(value)]="value"
    [readOnly]="!isEditing"
    [label]="label"
    [elementAttr]="{ class: 'form-editor' }"
    [inputAttr]="{ class: 'form-editor-input' }"
    stylingMode="filled"
    displayFormat="MM/dd/y"
    pickerType="calendar"
    (valueChange)="onValueChanged($event)"
  >
    <dx-validator [validationRules]="validationRules()"></dx-validator>
  </dx-date-box>`,
    imports: [DxDateBoxModule, DxValidatorModule]
})
export class FormDateboxComponent extends FormValidationComponent {
  @Input() isEditing = false;
  @Input() label = '';
  @Input() value!: string | Date | number;

  @Output() valueChange: EventEmitter<string | Date | number> = new EventEmitter();

  onValueChanged = (value: string | number | Date) => {
    this.value = value;
    this.valueChange.emit(this.value);
  };
}
